import React from "react";

import { wrap } from "./RydTestbedWrap";
import { RydDial } from "../components/widgets/data-input/RydDial";
import RydTernary from "../components/widgets/data-input/RydTernary";
import RydSliderInput from "../components/widgets/data-input/RydSliderInput";
import RydADSRInput from "../components/widgets/data-input/RydADSRInput";


export function RydNumericInputTestbed() {
    const [dialValue, setDialValue] = React.useState(50);
    const [ternaryValue, setTernaryValue] = React.useState([0.2, 0.3, 0.5]);
    const [sliderValue, setSliderValue] = React.useState(50);
    const [adsr, setAdsr] = React.useState({ attack: 0.1, decay: 0.2, sustain: 0.7, release: 0.3 });
    return wrap(<>
        {/* Add your testbed components here */}
        <h1>RydDial Testbed</h1>
        Value : {dialValue}<br />
        <RydDial min={10} max={100} initialValue={dialValue} update={setDialValue} />

        <h1>Ternary testbed</h1>
        Value : {ternaryValue.join(', ')} <br />
        <RydTernary onChange={(v) => setTernaryValue(v)}
            // value={[0.2, 0.3, 0.5]}
            labels={['A', 'B', 'C']}
        />

        <h1>Slider testbed</h1>
        Value: {sliderValue}<br />
        <RydSliderInput onChange={setSliderValue}
            value={sliderValue}
            step={0.1}
        />

        <h1>ADSR</h1>
        Value: <pre>{JSON.stringify(adsr)}</pre>
        <RydADSRInput value={adsr} onChange={setAdsr} />

    </>);
}